import Download from "./components/Download";
const downloads = document.querySelectorAll('.tx-frp-downloads');

downloads.forEach(($download) => {
    new Download($download);
});
